import styled, { css } from 'styled-components/macro';
import { Alert } from '@yme/atoms/alert';
import { AlertMessageWrapper } from '@yme/atoms/alert/styled';
import { Button } from '@yme/atoms/button';
import { colorAccentInfo900Base, colorCoreBlack900Base, colorCoreGray500, colorCoreGray800, colorCoreWhite1000, } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const DropdownMobileWrapperStyled = styled.div `
  width: auto;

  ${ADAPTIVE.maxWidth.mobile} {
    flex-basis: 100%;
  }

  ${ADAPTIVE.minWidth.tablet} {
    width: 231px;
  }
`;
export const TestRideGridWrapperStyled = styled.div `
  flex-basis: 100%;
  max-width: 1440px;
`;
export const ShowAllDealersButton = styled(RegularTextLevel4) `
  cursor: pointer;
  white-space: nowrap;
  text-decoration: underline;
  color: ${colorAccentInfo900Base};
`;
export const AlertStyled = styled(Alert) `
  ${AlertMessageWrapper} {
    flex: 1 1 100%;
  }
`;
export const AlertWrapper = styled.div `
  padding: 0 16px;

  ${ADAPTIVE.minWidth.tablet} {
    padding: 0 24px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    padding: 0 48px;
  }
`;
export const PreferredDealerWrapper = styled(FlexWrapper) `
  ${({ isDealerFieldVisible }) => !isDealerFieldVisible &&
    css `
      display: none;
    `}

  padding: 24px 16px;

  ${ADAPTIVE.minWidth.tablet} {
    padding: 24px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    padding: 48px;
  }

  background-color: ${colorCoreWhite1000};
`;
export const FilterByDealerButton = styled(Button) `
  ${getTextStyles('Ubuntu', 400, 14, 20)};

  width: 100%;
  margin-top: 24px;

  ${ADAPTIVE.minWidth.tablet} {
    width: auto;
    margin-top: 0;
  }

  text-transform: none;
  padding: 8px 16px;
  max-height: 44px;
  border-radius: 6px;
  border: 1px solid ${colorCoreGray500};
  background-color: ${colorCoreWhite1000};
  color: ${colorCoreBlack900Base};

  span {
    white-space: nowrap;
  }

  &:hover {
    border: 1px solid ${colorCoreGray800};
    background-color: ${colorCoreWhite1000};
  }
`;
